import _ from 'lodash';
import defaultState from 'pcb-parts/data/defaultState';
import { QUOTED } from 'pcb-parts/data/bomStatus';
import { getBomLineItemExtraData } from 'pcb-parts/utils/extracters';
import { PCB_PARTS_ID } from './bomConstants';

const state = {
  ...defaultState,
};

if (Spree.items_quote) {

  const variant = _.find([PCB_PARTS_ID], (v) => Spree.items_quote[v] !== undefined)

  if (variant) {
    const item = Spree.items_quote[variant];
    const parameters = Spree.items_parameters[variant];
    const {
      part_number,
      revision,
    } = parameters;
    const {
      bom,
      bom_file,
      line_item_id,
      product_quote_number,
    } = item;

    state.view.uploaded_zip_file = true;
    state.view.available_bom_in_zip = true;
    state.view.bom_selected = true;
    state.line_item_id = line_item_id;
    state.product_quote_number = product_quote_number;
    state.saved = true;
    state.bom_status = QUOTED;
    state.bom_file = bom_file;
    state.id = bom.id;
    state.name = part_number;
    state.revision = revision;
    state.board_qtys = bom.board_qtys;
    state.selected_board_qty = bom.selected_board_qty;
    state.base_totals = bom.base_totals;
    state.markups = bom.markups;
    state.shipping = bom.shipping;
    state.totals = bom.totals;
    state.bom_line_items = bom.bom_line_items;
    state.bom_line_items.forEach((bli, index) => {
      state.bom_line_items[index].error_message = {};
      state.board_qtys.forEach((board_qty) => {
        const { error_message } = getBomLineItemExtraData(
          state.bom_line_items[index],
          board_qty,
          bom.selected_board_qty,
        );
        state.bom_line_items[index].error_message[board_qty] = error_message;
      });
    });
  }
}


export default state;
